// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconArrowUpStroke.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconArrowUpStroke = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 12 16" fill="currentColor" { ...props }>
    <path d="M0.23852 6.79684C-0.0795868 6.46806 -0.0794256 5.93493 0.23852 5.60604L5.42393 0.246647C5.74212 -0.082216 6.25788 -0.082216 6.57607 0.246647L11.7615 5.60604C12.0794 5.93493 12.0796 6.46806 11.7615 6.79684C11.4434 7.12562 10.9275 7.12545 10.6093 6.79684L6.81477 2.87495L6.81477 16L5.18523 16L5.18523 2.87495L1.39066 6.79684C1.07245 7.12545 0.556627 7.12562 0.23852 6.79684Z" />
  </BaseIcon>
);

export default IconArrowUpStroke;
